import { createStyles, makeStyles, Theme } from 'cs-kevlar-react'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fieldsContainer: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      minHeight: 0,
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
    emptyValue: {
      paddingLeft: theme.spacing(8),
      paddingTop: theme.spacing(8),
      paddingRight: theme.spacing(8),
    },
  }),
)

export const useDetailStyles = () => {
  const classes = useStyles()
  return classes
}
